<template>
  <div class="pt-6 pb-6 md:py-12">
    <div class="max-w-5xl mx-auto px-4 sm:px-6 md:px-8">
      <div class="relative">
        <div class="absolute inset-0 flex items-center" aria-hidden="true">
          <div class="w-full border-t border-gray-300"></div>
        </div>
        <div class="relative flex items-center justify-between">
          <span class="pr-3 bg-gray-100 text-xl font-medium text-gray-900">
            {{ $t('general.enrollments') }}
          </span>
          <button type="button" v-on:click="this.navigationMenuStore.toggleSlideOverEnrolUser" class="inline-flex justify-center px-4 py-2 cursor-pointer border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-pink-500">
            <svg xmlns="http://www.w3.org/2000/svg" class="-ml-1 mr-2 h-5 w-5 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <span class="">Matricular</span>
          </button>
        </div>
      </div>
      <!-- Cargando Matriculaciones -->
      <div v-show="loading" class="flex justify-center mt-8 p-4 text-sm rounded-lg">
        <div class=" text-yellow-700">
          <svg class="inline mr-3 w-4 h-4 text-blue-700 animate-spin" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#E5E7EB"/>
            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor"/>
          </svg>
        </div>
        <span class="ml-1 text-lg text-gray-600">
              {{ $t('community.loading_enrols') }}
            </span>
      </div>
      <!-- Replace with your content -->
      <div class="py-4">
        <div class="flex flex-col">
          <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
            <div v-if="processingEnrol" class="flex justify-center mt-7 p-4 text-sm">
                <div class=" text-yellow-700">
                  <svg class="inline mr-3 w-4 h-4 text-blue-700 animate-spin" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#E5E7EB"/>
                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor"/>
                  </svg>
                </div>
                <span class="ml-1 text-gray-400">
                  {{ $t('community.processing') }}
                </span>
            </div>
            <div v-else-if="enrols != null && enrols.length > 0" class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200">
              <table class="min-w-full">
                <thead>
                <tr>
                  <th class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                    {{ $t('community.project_name') }}
                  </th>
                  <th class="hidden px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                    {{ $t('general.teachers') }}
                  </th>
                  <th class="hidden px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                    # {{ $t('general.students') }}
                  </th>
                  <th class="px-6 py-3 border-b border-gray-200 bg-gray-50"></th>
                </tr>
                </thead>
                <tbody class="bg-white">
                <tr v-for="enrol in enrols" :key="enrol.project.uuid" class="hover:bg-gray-50 transition-colors ease-in">
                  <td class="px-6 py-4 whitespace-no-wrap border-b border-gray-200">
                    <div class="flex items-center">
                      <div class="ml-4">
                        <div class="text-sm leading-5 font-medium text-gray-900">{{enrol.project.title}}</div>
                        <div class="text-sm leading-5 text-gray-500">{{ $t('community.updated_at') }} {{$moment(enrol.project.updated_at).format("LLLL")}}</div>
                      </div>
                    </div>
                  </td>
                  <td class="px-6 py-4 whitespace-no-wrap text-right border-b border-gray-200 text-sm leading-5 font-medium">
                    <div class="flex items-center justify-end">
                      <div v-if="enrol.status === 'complete' && this.user.role === 'Estudiante'" class="px-4 py-2 shadow-md bg-green-500 flex flex-shrink-0 text-white flex mx-4 rounded">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-5">
                          <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 0 1-1.043 3.296 3.745 3.745 0 0 1-3.296 1.043A3.745 3.745 0 0 1 12 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 0 1-3.296-1.043 3.745 3.745 0 0 1-1.043-3.296A3.745 3.745 0 0 1 3 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 0 1 1.043-3.296 3.746 3.746 0 0 1 3.296-1.043A3.746 3.746 0 0 1 12 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 0 1 3.296 1.043 3.746 3.746 0 0 1 1.043 3.296A3.745 3.745 0 0 1 21 12Z" />
                        </svg>
                        <label class="ml-2 font-semibold">{{ $t('community.completed') }}</label>
                      </div>


                      <!-- v-on:click="selectedProject(product.projects.uuid, product.projects.title)" -->
                      <button v-if="this.banAccess" @click="clickOnBanAccess(enrol.project.uuid)" id="ban_access" title="Denegar acceso" :disabled="loadingLMS" class="hidden flex flex-row justify-center text-red-600 transition-colors bg-red-100 pl-3 rounded hover:bg-red-200">
                        <div class="mt-1">{{ $t('community.access_denied') }}</div>
                        <div class="text-red-500 text-sm font-medium">
                          <div class="group mr-1 p-1 h-7 w-7" :aria-label="$t('community.to_cancel')">
                            <svg v-if="!loadingLMS" xmlns="http://www.w3.org/2000/svg" class="" viewBox="0 0 20 20" fill="currentColor">
                              <path fill-rule="evenodd" d="M13.477 14.89A6 6 0 015.11 6.524l8.367 8.368zm1.414-1.414L6.524 5.11a6 6 0 018.367 8.367zM18 10a8 8 0 11-16 0 8 8 0 0116 0z" clip-rule="evenodd" />
                            </svg>
                            <font-awesome-icon v-else class="h-7 w-7 text-gray-400 group-hover:text-gray-600 group-focus:text-gray-600 animate-spin" icon="spinner" size="lg" />
                          </div>
                        </div>
                      </button>
                      <button v-else title="Denegar acceso" @click="clickOnBanAccess(enrol.project)" id="ban_access" :disabled="loadingLMS" class="hidden group mr-2 p-1 h-7 w-7 text-gray-400 rounded-full hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:shadow-outline focus:text-gray-500" :aria-label="$t('community.to_cancel')">
                        <svg v-if="!loadingLMS" xmlns="http://www.w3.org/2000/svg" class="group-hover:text-red-600 transition-colors" viewBox="0 0 20 20" fill="currentColor">
                          <path fill-rule="evenodd" d="M13.477 14.89A6 6 0 015.11 6.524l8.367 8.368zm1.414-1.414L6.524 5.11a6 6 0 018.367 8.367zM18 10a8 8 0 11-16 0 8 8 0 0116 0z" clip-rule="evenodd" />
                        </svg>
                        <font-awesome-icon v-else class="h-7 w-7 text-gray-400 group-hover:text-gray-600 group-focus:text-gray-600 animate-spin" icon="spinner" size="lg" />
                      </button>
                      <button title="Dar de baja" @click="clickOnUnregister(enrol.project)" id="unregister" :disabled="loadingLMS" class="group mr-2 p-1 h-7 w-7 text-gray-400 rounded-full hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:shadow-outline focus:text-gray-500" :aria-label="$t('community.to_cancel')">
                        <svg v-if="!loadingLMS" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" class="group-hover:text-red-600 transition-colors" stroke="currentColor">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                        <font-awesome-icon v-else class="h-7 w-7 text-gray-400 group-hover:text-gray-600 group-focus:text-gray-600 animate-spin" icon="spinner" size="lg" />
                      </button>
                    </div>
                    <!--
                      Modal Component para borrado de matriculaciones.
                    -->
                    <teleport to="body">
                      <modal-component id="modal-delete-enrol" v-if="showModalDeleteEnroll" :onProcess="confirmModalDeleteEnroll" :onCancel="closeModalDeleteEnroll" :loading="false">
                        <template v-slot:header>{{ $t('community.modal_title') }}</template>
                        <p>{{ $t('community.modal_warning') }}</p>
                        <p class="font-bold mt-2">{{ $t('community.modal_question') }}"{{this.projectTitleSelected}}" ?</p>
                      </modal-component>
                    </teleport>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div v-else-if="!loading" class="flex justify-center m-3">
              <label class=" px-6 py-3 text-xs leading-4 font-bold text-gray-500 uppercase tracking-wider">{{ $t('community.no_enrolls') }}</label>
            </div>
          </div>
        </div>
      </div>

      <teleport to="body">
        <user-enrol-slide-over-component v-on:reload-enrols="getEnrolments" v-on:enrol-toggle-loading="toggleLoading"></user-enrol-slide-over-component>
      </teleport>

      <!-- /End replace -->
    </div>
  </div>
</template>

<script>
import EnrolService from "@/services/enrol/EnrolService";
import {useClassroomStore} from "@/stores/classroom";
import {useAuthUserStore} from "@/stores/auth";
import {useAcademiesStore} from "@/stores/academies";
import ModalComponent from "@/components/modals/ModalComponent";
import {useNavigationMenuStore} from "@/stores/navigationMenu";
import UserEnrolSlideOverComponent from "./UserEnrolSlideOverComponent";
import UserService from "@/services/user/UserService";
import userService from "@/services/user/UserService";

export default {
  name: "UserEnrolListComponent",
  components: { ModalComponent, UserEnrolSlideOverComponent},
  props: {
    user_id: null,
  },
  data: () => {
    return {
      loading: true,
      enrols: [],
      user: '',
      loadingLMS: false,
      showModalDeleteEnroll: false,
      showEnrollComponent: false,
      projectTitleSelected: null,
      projectUuidSelected: null,
      banAccess: false,
      processingEnrol: false,
    }
  },
  setup(){

    const authUserStore = useAuthUserStore();
    const academiesStore = useAcademiesStore();
    const navigationMenuStore = useNavigationMenuStore();

    return {
      classroomStore: useClassroomStore(),
      authUserStore,
      academiesStore,
      navigationMenuStore
    }
  },
  created() {
    this.getUser()
    this.getEnrolments()
  },
  methods: {
    getUser(){
      let academy_uuid = this.academiesStore.academy.uuid;
      let user_uuid = this.$route.params.id;
      userService.show(academy_uuid, user_uuid)
          .then((response) => {
            this.user = response.data
            console.log("Usuario en el enrollist", this.user)
          })
          .catch((error) => {
            console.log("Error al obtener usuario: ", error)
          })
          .finally(() => {
            this.loading = false
          })
    },
    getEnrolments()
    {
      this.loading = true
      let academy_user_id = this.$route.params.id;
      UserService.getEnrolments(academy_user_id)
          .then((response) => {
            console.log("Obteniendo matriculaciones: ", response.data)
            this.enrols = response.data.enrols
          })
          .catch((error) => {
            console.log("Error al obtener matriculaciones: ", error)
          })
          .finally(() => {
            this.loading = false
          })
    },
    toggleLoading(value)
    {
      this.processingEnrol = value
    },
    // TODO: Mover toggle modal
    //...mapActions(["toggleModal"]),
    goToMoodleCourse(uuid) {
      this.classroomStore.open(uuid, this.$t)
    },
    clickOnUnregister(project) {
      this.showModalDeleteEnroll=true
      this.projectTitleSelected = project.title
      this.projectUuidSelected = project.uuid
      console.log("El proyecto a desmatricular es: ", this.projectTitleSelected)
    },
    closeModalDeleteEnroll() {
      return this.showModalDeleteEnroll = false
    },
    confirmModalDeleteEnroll() {
      this.showModalDeleteEnroll = false
      this.deleteEnrol()
    },
    deleteEnrol() {
        let user_id = this.$route.params.id;
        EnrolService.delete(this.projectUuidSelected, user_id)
            .then((response) => {
              console.log(response)
              //Recargará las
              this.getEnrolments()
            })
            .finally(() => {
                this.loading = false
              this.projectUuidSelected = ''
              this.projectTitleSelected = ''
            })
    },
    clickOnBanAccess (project_uuid) {
      console.log("El uuid del curso a 'banear' es: ", project_uuid)
      //Llamar a endpoint para banear el acceso al curso.
      this.banAccess = !this.banAccess
    },

  }
}
</script>

<style scoped>

</style>